module.exports = __webpack_public_path__ + "img/check.07b613e.svg";